import { Component, Inject, OnInit } from '@angular/core';
import { APP_CONFIG } from '@mnz-core/injectors/app-configuration';
import { Language } from '@mnz-core/models/_enums';
import { IAppConfiguration } from '@mnz-core/models/app-configuration';
import { TranslateService } from '@ngx-translate/core';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'mnz-root',
  templateUrl: 'app.component.html',
})
export class AppComponent implements OnInit {
  desribeMetaTag: string;
  constructor(
    @Inject(APP_CONFIG) public readonly config: IAppConfiguration,
    private readonly _translate: TranslateService,
    private metaService: Meta
  ) {
    this._translate.setDefaultLang(Language.DUTCH);

    const { relay42_config } = this.config;
    this._translate.use(relay42_config.language);

    this.desribeMetaTag = relay42_config.language === Language.DUTCH
        ? 'Wilt u inloggen op Mijn NS Zakelijk? Als contactpersoon en/of kaarthouder regelt u al uw zaken online.'
        : 'Do you want to log in to My NS Business? If contact and / or cardholder you control all your business needs online.';
  }

  ngOnInit(): void {
    this.metaService.updateTag({ name: 'description', content: this.desribeMetaTag });
  }
}
